import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { Linking } from "react-native";
import { logger } from "./logger";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Returns distance in km between two lat/lng coordinates (Haversine formula). */
export function haversineDistanceKm(
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number
): number {
  const R = 6371;
  const toRad = (x: number) => (x * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

/**
 * Allowed URL schemes for external links
 */
const ALLOWED_URL_SCHEMES = ["https:", "http:"];

/**
 * Safely opens a URL after validating the scheme.
 * Only allows http:// and https:// URLs to prevent malicious schemes.
 */
export function safeOpenURL(url: string): void {
  try {
    const parsed = new URL(url);
    if (!ALLOWED_URL_SCHEMES.includes(parsed.protocol)) {
      logger.warn("Blocked URL with disallowed scheme", {
        scheme: parsed.protocol,
        url,
      });
      return;
    }
    Linking.openURL(url);
  } catch {
    logger.warn("Invalid URL format", { url });
  }
}
